export default {
  // Phiếu thu
  CAReceipt: 20,
  // Phiếu chi
  CAPayment: 21,
  // Nộp tiền Kho bạc
  BADeposit: 30,
  // Rút tiền Kho bạc
  BUTreasuryWithdrawal: 31,
  // Chuyển tiền nội bộ
  BAInternalTransfer: 32,
  // Chi tiền gửi
  BAWithDraw: 33,
  // Chuyển khoản kho bạc
  BUTransfer: 34,
  // Đề nghị cam kết chi *
  BUCommitmentRequest: 42,
  // Điều chỉnh cam kết chi *
  BUPlanAdjustCommit: 43,
  // Kết chuyển chênh lệch thu, chi ngân sách xã
  TranferReceiptClear: 130,
  // Kết chuyển cuối năm
  TranferClosing: 132,
  // Kết chuyển kết dư sang thu ngân sách xã
  TransferBudgetBalance: 133,
  // Kết chuyển hoạt động sự nghiệp
  TransferActivity: 134,
  // Quyết toán dự toán chi ngân sách cuối năm
  TransferBegining: 135,
  // Kết chuyển chênh lệch thu, chi ngân sách trong thời gian chỉnh lý
  TranferReceiptClearInMonth13: 136,
  // Nhận dự toán đầu năm
  BUReceiveBudgetPlan: 154,
  // Nhận dự toán bổ sung
  BUReceiveBudgetPlanSupplement: 155,
  // Nhập khác
  INInward: 60,
  // Nhập mua bằng tiền mặt
  InventoryInwardCash: 62,
  // Nhập mua bằng tiền gửi
  InventoryInwardDeposit: 63,
  // Phiếu xuất kho
  INOutward: 61,
  // Phiếu ghi tăng CCDC
  ToolIncrement: 74,
  // Phiếu ghi giảm CCDC
  ToolDecrement: 75,
  // Chuyển kho
  InventoryTransfer: 64,
  // Phiếu điều chuyển CCDC
  ToolTransfer: 77,
  // Chuyển khoản kho bạc vào tài khoản tiền gửi
  BUTransferDeposit: 165,
};
